
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutOperator from "../pages/about-operator/page";
import Tokushoho from "../pages/tokushoho/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import Support from "../pages/support/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about-operator",
    element: <AboutOperator />,
  },
  {
    path: "/tokushoho",
    element: <Tokushoho />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/support",
    element: <Support />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
